import React from 'react';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';
import { DesignContextProvider } from 'context/DesignProvider';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { localeUtils } from 'utils/locale';
import { QueryClientProvider } from '@tanstack/react-query';
import { NotificationProvider } from '@wix/gg-components';
import { FlowProvider } from 'context/FlowProvider';
import { queryClient } from '../../api';
import { AppLayout } from './AppLayout';

const ARTIFACT_ID = 'com.wixpress.ai-store-builder';

const essentials = createEssentials({
  environment: {
    language: 'en',
    artifactId: ARTIFACT_ID,
    version: '1.0.0',
  },
  experiments: {
    bag: {},
  },
  fedops: {},
  dataCapsule: {
    namespace: ARTIFACT_ID,
    storageStrategy: 'localStorage',
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={localeUtils.getI18n()}>
        <RootEssentialsProvider essentials={essentials}>
          <DesignContextProvider>
            <NotificationProvider>
              <FlowProvider>
                <AppLayout />
              </FlowProvider>
            </NotificationProvider>
          </DesignContextProvider>
        </RootEssentialsProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
